import { render, staticRenderFns } from "./CreateVolumeDialog.vue?vue&type=template&id=7a547281"
import script from "./CreateVolumeDialog.vue?vue&type=script&lang=js"
export * from "./CreateVolumeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports